import { render, staticRenderFns } from "./PatientDetailNote.vue?vue&type=template&id=23399993&"
import script from "./PatientDetailNote.vue?vue&type=script&lang=ts&"
export * from "./PatientDetailNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports